import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslocoDirective } from "@jsverse/transloco";
import { StrategyActivityComponent } from "@m19-board/strategies/strategies/strategy-activities/strategy-activities.component";
import { toSignal } from "@angular/core/rxjs-interop";
import { AuthService, UserSelectionService } from "@front/m19-services";
import { DateTime } from "luxon";
import { API_DATE_FORMAT } from "@front/m19-utils";
import { StrategyPageService } from "@m19-board/strategies/strategy-page/strategy-page.service";

@Component({
  selector: "app-strategy-page-activities",
  imports: [CommonModule, TranslocoDirective, StrategyActivityComponent],
  templateUrl: "./strategy-page-activities.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyPageActivitiesComponent {
  private readonly strategyPageService = inject(StrategyPageService);
  private readonly authService = inject(AuthService);
  private readonly userSelectionService = inject(UserSelectionService);

  strategy = this.strategyPageService.strategy;
  locale = toSignal(this.authService.userLocale$);

  dateRange = toSignal(this.userSelectionService.dateRange$, { requireSync: true });
  maxActivitiesDate = computed(() => {
    if (!this.dateRange()) return "";
    if (this.dateRange()![1] == DateTime.now().minus({ day: 1 }).toFormat(API_DATE_FORMAT)) {
      return DateTime.now().toFormat(API_DATE_FORMAT);
    }
    return this.dateRange()![1];
  });
}
